import React from 'react';
import { DeploymentProcessStep } from './steps/DeploymentProcessStep';
import { CreateAppStep } from './steps/CreateAppStep';
import {
  SelfHostedModalContextProvider,
  useSelfHostedContext,
} from './SelfHostedModalContextProvider';
import { TestYourAppStep } from './steps/TestYourAppStep';

export const SelfHostedModalBase = () => {
  const { activeStep } = useSelfHostedContext();
  return (
    <>
      {activeStep === 0 && <DeploymentProcessStep />}
      {activeStep === 1 && <CreateAppStep />}
      {activeStep === 2 && <TestYourAppStep />}
    </>
  );
};
export const SelfHostedModal = ({ closeModal }) => (
  <SelfHostedModalContextProvider onClose={closeModal}>
    <SelfHostedModalBase />
  </SelfHostedModalContextProvider>
);
